import { olx } from 'openlayers';
import { BehaviorSubject } from 'rxjs';
import { CustomOlControl } from './custom-ol-control';

export class CloseFullscreenControl extends CustomOlControl {
  isVisible$: BehaviorSubject<boolean>;

  constructor(isVisible$: BehaviorSubject<boolean>, options: olx.control.ControlOptions = {}) {
    const buttonClass = 'bom-ol-close-fullscreen icon-svg';
    const classNameOn = 'icon-close';
    const classNameOff = 'hidden';

    super(() => this.click(), buttonClass, options);

    this.isVisible$ = isVisible$;
    this.isVisible$.subscribe(isToggled => {
      this.setClass(isToggled ? classNameOn : classNameOff);
    });
  }

  click() {
    this.isVisible$.next(!this.isVisible$.value);
  }
}
